<template>

    <div v-if="loading" class="checkout-loading">
        <div class="d-flex justify-content-center">
            <i class="icon icon-clock"></i>
        </div>
        <div class="row">
            <p>
                <translate item="DeliveryTimePleaseWait" />
            </p>
        </div>
    </div>
    <div v-else>

        <div class="vertical-accordeon-title row">
            <span class="separator fat-separator"></span>
            <div class="col-12">
                <h3>{{title}}</h3>
            </div>
            <span class="separator fat-separator"></span>
        </div>

        <div class="row">
            <div class="col" v-for="day in availableDays">
                <label v-on:click="dayClick(day)" class="btn desiredTime day" v-bind:class="{on : day.selected, disabled : !day.Enabled}">
                    <span v-if="showPlanButton">Je plant voor vandaag, </span><span v-html="day.Name"></span>
                </label>
            </div>
        </div>
        <span class="separator fat-separator separator-availableDays"></span>
        <div class="row">
            <div class="col" v-for="day in availableDayParts">
                <label v-on:click="dayPartClick(day)" class="btn desiredTime daypart" v-bind:class="{on : day.selected, disabled : !day.Enabled}">{{day.Name}}</label>
            </div>
        </div>

        <div v-if="!hours.length" class="checkout-loading">
            <div class="d-flex justify-content-center">
                <i class="icon icon-clock"></i>
            </div>
            <div class="row">
                <p>
                    <translate item="DeliveryTimePleaseWait" />
                </p>
            </div>
        </div>

        <div v-if="!shoppingDisabled">

            <span class="separator fat-separator separator-time-first"></span>
            <div class="row hours">
                <div class="col-4" v-for="hour in hours">
                    <label v-on:click="hourClick(hour)" class="btn desiredTime hour" v-bind:class="{on : hour.hour == selectedHour, disabled : !hour.Enabled, avoidTime : hour.Enabled && !hour.Preferred}">{{hour.Name}}</label>
                </div>
            </div>

            <span class="separator fat-separator separator-time-second"></span>

            <div v-if="daypartloading" class="checkout-loading">
                <div class="d-flex justify-content-center">
                    <i class="icon icon-clock"></i>
                </div>
                <div class="row">
                    <p>
                        <translate item="DeliveryTimePleaseWait" />
                    </p>
                </div>
            </div>
            <div v-else class="row minutes">
                <div class="col-4" v-for="minute in minutes">
                    <label v-on:click="minuteClick(minute)" class="btn desiredTime minute" v-bind:class="{on : (minute.minute <= selectedMinute && minute.minute + 5 >= selectedMinute ), disabled : !minute.Enabled, avoidTime: minute.Enabled && !minute.Preferred}">
                        <!--<input v-bind:selected="(minute.minute <= selectedMinute && minute.minute + 5 >= selectedMinute )" type="radio" name="DesiredTimeDay" v-bind:value="dayPartString + ' ' + selectedHour + ':' + minute.Name" />-->
                        {{selectedHour}}:{{minute.Name}}
                    </label>
                </div>
            </div>

            <div v-if="showPlanButton && cart.model.totalItems > 0" v-on:click="placeOrder" class="row plan-button">
                <div class="col-3 plan-button">
                    <button type="submit" class="btn btn-default">
                        <span class="caption">Inplannen</span>
                    </button>
                </div>
            </div>

        </div>


        <input type="hidden" name="DesiredTimeDay" v-bind:value="dayPartString + ' ' + selectedHour + ':' + selectedMinute" />

    </div>
</template>

<script>

  
    import shoppingCartService from '../Services/ShopingCartService';
    import translate from './translate';
    //shoppingCartService.shoppingCart.model.totalItems

    export default {
        name: 'delivery-time',
        components: { translate },
        data: function () {
            /*
             *
             * Example of the structure
            window.availableDays = {
              "AvailableDays":
                [{
                  "AvailableDayPart":
                    [{
                      "FirstTime": "2020-11-30T12:00:00", "LastTime": "2020-11-30T12:00:00",
                      "Name": "Ochtend", "Enabled": false, "selected": false
                    }, {
                      "FirstTime": "2020-11-30T12:00:00", "LastTime": "2020-11-30T18:00:00",
                      "Name": "Middag", "Enabled": true, "selected": true
                    }, {
                      "FirstTime": "2020-11-30T18:00:00", "LastTime": "2020-11-30T20:00:00",
                      "Name": "Avond", "Enabled": true, "selected": false
                    }], "DayPartstring": "30-11-20", "FirstTime": "2020-11-30T12:50:00", "LastTime": "2020-11-30T20:00:00",
                  "Name": "Vandaag<br/>ma 30 nov", "Enabled": true, "selected": true
                }, {
                  "AvailableDayPart": [{
                    "FirstTime": "2020-12-01T12:00:00", "LastTime": "2020-11-01T12:00:00",
                    "Name": "Ochtend", "Enabled": false, "selected": false
                  }, {
                    "FirstTime": "2020-11-01T12:00:00", "LastTime": "2020-11-01T18:00:00",
                    "Name": "Middag", "Enabled": false, "selected": false
                  }, {
                    "FirstTime": "2020-11-01T18:00:00", "LastTime": "2020-12-01T20:00:00",
                    "Name": "Avond", "Enabled": true, "selected": false
                  }], "DayPartstring": "01-12-20", "FirstTime": "2020-12-01T12:00:00",
                  "LastTime": "2020-12-01T20:00:00", "Name": "Morgen<br/>di 01 dec", "Enabled": true, "selected": false
                }]
            };
            */
            return {
                availableDays: [], // window.availableDays.AvailableDays, // the available days
                availableDayParts: {},  // the available dayparts
                selectedDay: {},        // the selected day
                selectedDayPart: {},    // the selected daypart
                selectedHour: -1,       // the selected hour
                selectedMinute: -1      // the selected minute
                , firstAvailableTime: {} // the first available time on the selected day.
                , dayPartString: '',
                cart: shoppingCartService.shoppingCart,
                interval: null,
                message: '',
                title: '',
                shoppingDisabled: false,
                loading: true,
                daypartloading : false,
                hours: [],
                minutes: [],
                intervalList: []
            }
        },
        props: {
            minuteInterval: { type: Number, default: 10 },
            showPlanButton: { type: Boolean, default: false }
        },
        methods: {

            placeOrder: function () {
                var vm = this;

                navState.setNavState('wait');

                if (this.checkoutLink && this.checkoutLink.length) {
                    window.location.href = this.checkoutLink;
                    return false;
                }

                shoppingCartService.posOrderSubmit().then(function (data) {

                    navState.setNavState();

                    if (data.Ok) {
                        vm.printed = true;
                        if (data.Redirect.length) {
                            window.location.href = data.Redirect;
                        }
                    } else {
                        alert(data.Message);
                    }
                });
            },
            /**
             * Handles the click on the day
             * @param day object
             */
            dayClick: function (day) {
                if (!day.Enabled) {
                    return;
                }
                // deselect current selection
                this.selectedDay.selected = false;

                // select new selection
                day.selected = true;

                if (this.selectedDay.Name != day.Name) {
                    // deselect current daypart
                    this.selectedDayPart.selected = false;
                }

                this.selectedDay = day;

                // set the dayparts of this day
                this.availableDayParts = day.AvailableDayPart;

                // find and select the new daypart
                var enabledDayparts = this.selectedDay.AvailableDayPart.filter(function (a) { return a.selected && a.Enabled });

                if (enabledDayparts.length == 0) {
                    enabledDayparts = this.selectedDay.AvailableDayPart.filter(function (a) { return a.Enabled });
                }

                if (enabledDayparts && enabledDayparts.length) {
                    this.selectedDayPart = enabledDayparts[0];
                    this.dayPartClick(enabledDayparts[0]);
                } else {
                    day.Enabled = false;

                    var enabledDays = this.availableDays.filter(function (a) { return a.Enabled });
                    if (enabledDays.length) {
                        this.dayClick(enabledDays[0]);
                    }                    

                }


            },

            /**
             * Handles the click on the daypart (ochtend/middag/avond)
             * @param dayPart
             */
            dayPartClick: function (dayPart) {

                if (!dayPart.Enabled) {
                    return;
                }
                // deslect current daypart
                this.selectedDayPart.selected = false;

                // set and set the selected state of the new daypart
                dayPart.selected = true;

                if (this.selectedDayPart != dayPart) {
                    this.hours = [];
                    this.minutes = [];
                }

                this.selectedDayPart = dayPart;
                this.dayPartString = this.selectedDay.DayPartstring;

                var _this = this;
                var _hour = -1;
                
                _this.daypartloading = true;
                shoppingCartService.loadTimeTable(this.selectedDayPart.FirstTime, this.selectedDayPart.LastTime, this.minuteInterval, function (result) {

                    var _hours = [];
                    var hour, hourto;
                    _this.hours = [];
                                        
                    for (var index in result) {
                        let date = new Date(result[index]);

                        hour = date.getHours();

                        if (_hour != hour) {
                            _hours.push(hour);
                            _hour = hour;
                            _this.intervalList[hour] = [];
                        }

                        _this.intervalList[hour].push(date.getMinutes());
                    }

                    // hours to render, selecteddaypart times are set fixed by the server (opendate - 12 | 12 - 18 | 18 - closedate)
                    hour = new Date(_this.selectedDayPart.FirstTime).getHours();
                    hourto = new Date(_this.selectedDayPart.LastTime).getHours();

                    // Pre-calculate the preferred start and end hours
                    var firstPreferredHour = -1;
                    const preferredStart = new Date(_this.selectedDayPart.FirstPreferedTime).getHours();
                    const preferredEnd = new Date(_this.selectedDayPart.LastPreferedTime).getHours();

                    while (hour <= hourto) {

                        const isPreferred = hour >= preferredStart && hour <= preferredEnd;

                        if (isPreferred && firstPreferredHour < 0) {
                            firstPreferredHour = hour;
                            _this.selectedHour = hour;
                        }

                        _this.hours.push({
                            Name: hour + ':00',
                            hour: hour,
                            Enabled: _hours.indexOf(hour) >= 0,
                            Preferred: isPreferred
                        });
                        hour++;

                    }

                    var selectedHour = _this.hours.find(a => a.Enabled && a.hour == _this.selectedHour);

                    // find first selected hour.
                    if (!selectedHour) {
                        selectedHour = _this.hours.find(a => a.Enabled);
                    }
                    // all hours disabled
                    if (!selectedHour) {

                        _this.selectedDayPart.selected = false;
                        _this.selectedDayPart.Enabled = false;

                        // find and select the new daypart
                        var enabledDayparts = _this.selectedDay.AvailableDayPart.filter(function (a) { return a.Enabled });

                        // not found, get next day
                        if (!enabledDayparts || !enabledDayparts.length) {
                            _this.selectedDay.selected = false;
                            _this.selectedDay.Enabled = false;
                            // .find is not available for ie, so use filter!
                            var enabledDays = _this.availableDays.filter(function (a) { return a.Enabled });

                            if (enabledDays && enabledDays.length) {
                                _this.dayClick(enabledDays[0]);
                            } else {
                                _this.shoppingDisabled = true;
                            }
                        } else {
                            _this.selectedDayPart = enabledDayparts[0];
                            _this.dayPartClick(enabledDayparts[0]);
                        }

                    }
                    _this.daypartloading = false;
                    _this.hourClick(selectedHour);
                });
            },

            /**
             * Handles the click on the hour
             * @param hour
             */
            hourClick: function (hour) {

                if (!hour || !hour.Enabled) {
                    return false;
                }

                this.selectedHour = hour.hour;

                var minute = 0;
                this.minutes = [];

                // available minutes in this hour.
                var availableMinutes = this.intervalList[hour.hour];

                // check preferred times (for party bookings)
                var firstPreferredMinute = -1;
                const preferredTimeStart = new Date(this.selectedDayPart.FirstPreferedTime);
                const preferredTimeEnd = new Date(this.selectedDayPart.LastPreferedTime);
                
                while (minute <= 59) {
                                      
                    var enabled = availableMinutes.some(a => {                        
                        var _enabled = (a + this.minuteInterval >= minute && a + this.minuteInterval <= minute + this.minuteInterval);
                        return _enabled;
                    });

                    // check with preferred times
                    const dtCurrentStart = new Date(this.selectedDay.DayPartstring).setHours(hour.hour, minute, 0, 0);
                    const dtCurrentEnd = new Date(this.selectedDay.DayPartstring).setHours(hour.hour, minute + this.minuteInterval, 0, 0);
                    const isPreferredMinute = enabled && (dtCurrentStart >= preferredTimeStart && dtCurrentEnd <= preferredTimeEnd)

                    if (isPreferredMinute && firstPreferredMinute < 0) {
                        firstPreferredMinute = minute;
                        this.selectedMinute = minute;
                    }

                    this.minutes.push({
                        Name: minute.toLocaleString('en', { minimumIntegerDigits: 2, minimumFractionDigits: 0, useGrouping: false }),
                        minute: minute,
                        Enabled: enabled,
                        Preferred: isPreferredMinute
                    });

                    minute += this.minuteInterval;

                }

                var selectedMinute = this.minutes.find(a => a.Enabled && a.minute == this.selectedMinute);

                if (!selectedMinute) {
                    // find first selected minute.
                    selectedMinute = this.minutes.find(a => a.Enabled);
                }

                this.minuteClick(selectedMinute);

            },

            /**
             * Handles the click on the minuts
             * @param minute
             */
            minuteClick: function (minute) {
                if (!minute.Enabled) {
                    return false;
                }
                this.selectedMinute = minute.minute;
            },

            // Get new first available time planning
            requestNew: function (initial) {

                var _this = this;
                _this.loading = true;

                // initial loading of the days
                shoppingCartService.loadDeliveryTime(function (deliveryData) {
                    var days = deliveryData.AvailableDays;

                    _this.availableDays = days;
                  
                    // .find is not available for ie, so use filter!
                    var enabledDays = _this.availableDays.filter(function (a) { return a.Enabled });

                    if (enabledDays && enabledDays.length) {
                        _this.dayClick(enabledDays[0]);
                    }
                    
                    _this.message = deliveryData.Message;
                    _this.title = deliveryData.Title;
                    _this.shoppingDisabled = deliveryData.ShoppingDisabled;
                    _this.loading = false;

                    if (_this.interval) {
                        clearTimeout(_this.interval);                       
                    }

                    // 1 minutues
                    _this.interval = setTimeout(_this.doAutoRefresh, 60000);
                });

            },


            //  timed auto refresh
            doAutoRefresh: function () {

                if (this.interval) {
                    clearTimeout(this.interval);
                }

                // find and select the new daypart
                var enabledDayparts = this.selectedDay.AvailableDayPart.filter(function (a) { return a.selected && a.Enabled });

                if (enabledDayparts.length == 0) {
                    enabledDayparts = this.selectedDay.AvailableDayPart.filter(function (a) { return a.Enabled });
                }

                if (enabledDayparts && enabledDayparts.length) {
                    this.selectedDayPart = enabledDayparts[0];
                    this.dayPartClick(enabledDayparts[0]);
                }

                // 1 minutues
                this.interval = setTimeout(this.doAutoRefresh, 60000);
            }
        },
        computed: {

            //minutes: function () {

            //    var minutes = [];
            //    var minute = 0;

            //    // first valid hour
            //    var firstTimeHour = new Date(this.selectedDay.FirstTime).getHours();

            //    // first valid minute
            //    var firstTimeMnute = new Date(this.selectedDay.FirstTime).getMinutes();

            //    // first valid hour
            //    var lastTimeHour = new Date(this.selectedDay.LastTime).getHours();

            //    // first valid minute
            //    var lastTimeMnute = new Date(this.selectedDay.LastTime).getMinutes();

            //    while (minute <= 59) {
            //        minutes.push({
            //            Name: minute.toLocaleString('en', { minimumIntegerDigits: 2, minimumFractionDigits: 0, useGrouping: false }),
            //            minute: minute,
            //            Enabled: (this.selectedHour > firstTimeHour || minute >= firstTimeMnute) && (this.selectedHour < lastTimeHour || minute < lastTimeMnute)
            //        });
            //        minute += 10;
            //    }
            //    return minutes;
            //}
        },

        watch: {
            "cart.dirty": function (val) {
                if (!val)
                    this.doAutoRefresh();
            }
        },

        mounted: function () {

            this.requestNew(true);
            var vm = this;

            // call back handler, shippingmethod selection is processed by api, and returned here
            $(Amazilia).on('shippingMethodSubmited', function (e, data) {
                vm.requestNew(false);
            });

        }, beforeDestroy
            : function () {
                clearTimeout(this.interval);
                this.interval = null;
            }

    }


</script>



// WEBPACK FOOTER //
// Vue/Src/Components/delivery-time.vue